import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ErrorMsg.scss';
export const ErrorMsg = (props) => {
    return (_jsxs("div", Object.assign({ className: 'error-msg' }, { children: [_jsx("h3", { children: "Error Occurred:" }), _jsx("h4", { children: props.errorMsg }), props.error && (_jsx("details", Object.assign({ style: { whiteSpace: 'pre-wrap' }, open: true }, { children: props.error.stack })))] })));
};
